import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=d1ffef6a&scoped=true&"
import script from "./GeneralInformation.vue?vue&type=script&lang=js&"
export * from "./GeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=d1ffef6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ffef6a",
  null
  
)

export default component.exports